import React, { useContext, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Sider from 'antd/es/layout/Sider';
import {
  Badge,
  ListItemIcon,
  MenuItem,
  MenuList,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';

import { MENU } from 'constants/menu.config';
import { PropertyContext } from './PropertyContext/PropertyContext';
import { datacontext } from 'modules/AppLayout/AppLayout';

import { ReactComponent as CollapseIcon } from 'assets/icons/collapse.svg';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand.svg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ReactComponent as Filemanagericon } from 'assets/svg/Paper.svg';

const SiderComponent = ({ isStickyAddress, ismessage }) => {
  const theme = useTheme();
  const history = useHistory();

  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const dataType = userDetail?.userType;

  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const { collapsed, setCollapsed, isBinderChatOpen } =
    useContext(PropertyContext);

  const {
    onCollapse,
    toggleMenu,
    setShowMessage,
    showMessage,
    msgcount,
    menubtn,
    openlogin,
    setOpenlogin,
    isOpenFileManager,
    setIsOpenFileManager,
  } = useContext(datacontext);
  const currentPage = window.location.pathname;
  const ismarket = currentPage.includes('/market');
  const topOffset = !ismarket
    ? dataType?.length === 1 && userDetail?.primaryUserType !== 'Agent'
      ? 72
      : 125
    : isBinderChatOpen
    ? 75
    : isStickyAddress
    ? 165
    : showMessage
    ? 70
    : 0;

  //icon wrapper to show tooltip when sider is collapsed
  const IconWrapper = ({ name, children }) =>
    collapsed ? (
      <Tooltip
        title={name}
        placement="right"
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: '18px',
              fontWeight: 400,
              padding: '8px 12px',
              fontFamily: 'Poppins !important',
            },
          },
        }}
      >
        <span>{children}</span>
      </Tooltip>
    ) : (
      children
    );

  const showFileManager = currentPage.match(/\/\d+$/);

  // 1. Copy the original menu array
  let updatedMenu = [...MENU.all_users];

  // 2. Filter out 'Insights' if the user is a Buyer
  if (userDetail?.primaryUserType === 'Buyer') {
    updatedMenu = updatedMenu.filter((m) => m.menu_name !== 'Insights');
  }

  // 3. Inject 'File Manager' if on the correct page pattern
  if (showFileManager) {
    const MarketplaceIndex = updatedMenu.findIndex(
      (m) => m.menu_name === 'Marketplace'
    );

    updatedMenu.splice(MarketplaceIndex, 0, {
      menu_name: 'File Manager',
      menu_icon: <Filemanagericon width={23} height={23} />,
      active_menu_icon: <Filemanagericon width={23} height={23} />,
      isFileManager: true,
    });
  }

  return (
    <>
      {(!matcheslg || menubtn) && !currentPage.includes('/Savedsearch') && (
        <>
          <div
            id="sticky"
            style={{
              position: isStickyAddress ? 'fixed' : 'absolute',
              top: isStickyAddress ? `${topOffset}px` : 'auto',
              marginTop: ismessage
                ? 0
                : !isStickyAddress
                ? `${topOffset}px`
                : '0px',
              padding: '0px',
              height: '100%',
            }}
          >
            <Sider
              width={currentPage.includes('/share') ? '0px' : '253px'}
              // height={"100%"}
              className="slider-menu-bar"
              collapsedWidth={currentPage.includes('/share') ? '0px' : '106'}
              trigger={null}
              collapsible
              key="app-slider"
              collapsed={collapsed}
              onCollapse={onCollapse}
              sx={{ bgcolor: '#fff' }}
              style={{
                overflow: 'auto',
                height: '100%',
                position: 'relative',
                left: 0,

                bottom: 0,
              }}
            >
              <span
                className="menu-trigger"
                onClick={() => toggleMenu()}
                style={{
                  zIndex: 10000,
                  position: 'absolute',
                  right: '5px',
                  top: window.innerHeight < 800 ? '30px' : '65px',
                  cursor: 'pointer',
                }}
                role="button"
                tabIndex={0}
              >
                {collapsed ? <ExpandIcon /> : <CollapseIcon />}
              </span>
              <div
                style={{
                  padding: 0,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                {/* <div id="leftCol"> */}
                <MenuList
                  defaultselectedkeys={['/dashboard']}
                  mode="vertical"
                  style={{
                    paddingTop: window.innerHeight < 700 ? '30px' : '60px',
                    height: '80%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  {updatedMenu.map((menu, index) => {
                    if (
                      menu.menu_name === 'Pipeline' &&
                      userDetail?.primaryUserType !== 'Agent'
                    ) {
                      return null;
                    }
                    const isActive = menu.isFileManager
                      ? isOpenFileManager
                      : showMessage
                      ? menu.menu_name === 'Messaging'
                      : isOpenFileManager
                      ? false // 👈 this disables all other menus when file manager is open
                      : currentPage.includes(menu.link);

                    return (
                      <div
                        key={index}
                        // className={`topMenu topMenu-${index} `}
                        style={{
                          paddingTop: window.innerHeight < 600 ? '0vh' : '3vh',
                          borderRadius: 'none !important',
                        }}
                      >
                        <MenuItem
                          className={
                            isActive ? 'null1' : collapsed ? 'null' : 'item'
                          }
                          onClick={() => {
                            if (menu.isFileManager) {
                              setIsOpenFileManager((prev) => !prev);
                              setCollapsed(true);
                              return;
                            }

                            // reset File Manager when navigating elsewhere
                            setIsOpenFileManager(false);

                            if (currentPage.includes('/share')) {
                              setOpenlogin(!openlogin);
                            } else if (menu.menu_name === 'Messaging') {
                              setShowMessage(!showMessage);
                              setCollapsed(true);
                            } else {
                              history.push(menu.link);
                              setShowMessage(false);
                              setCollapsed(true);
                            }
                          }}
                        >
                          <div className="side">
                            <Typography
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: 300,
                                fontSize: '14px',
                              }}
                            >
                              <IconWrapper name={menu.menu_name}>
                                <ListItemIcon
                                  className={isActive && 'click'}
                                  sx={{
                                    marginLeft: '10px',
                                    display: 'flex',
                                    height:
                                      window.innerHeight < 600
                                        ? '35px'
                                        : window.innerHeight < 700
                                        ? '40px'
                                        : '50px',
                                    width:
                                      window.innerHeight < 600
                                        ? '35px'
                                        : window.innerHeight < 700
                                        ? '40px'
                                        : '50px',

                                    background: isActive
                                      ? 'linear-gradient(162.58deg, #6c2ad2 1.87%, #77cffe 98.78%)'
                                      : 'transparent',

                                    borderRadius: '50%',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '5px',
                                  }}
                                >
                                  {menu.menu_name == 'Messaging' && msgcount ? (
                                    <Badge
                                      badgeContent={msgcount}
                                      color="error"
                                    >
                                      {isActive
                                        ? menu.menu_icon
                                        : menu.active_menu_icon}
                                    </Badge>
                                  ) : (
                                    <>
                                      {isActive
                                        ? menu.menu_icon
                                        : menu.active_menu_icon}
                                    </>
                                  )}
                                </ListItemIcon>
                              </IconWrapper>
                            </Typography>
                          </div>
                          {!collapsed && (
                            <Typography
                              className={isActive && 'table'}
                              sx={{
                                fontFamily: isActive ? 'poppins' : 'poppins',

                                fontSize: '16px',
                                fontWeight: isActive ? 500 : 300,

                                color: isActive && '#6F61E1',

                                marginLeft: '30px',
                                display: 'flex',
                              }}
                            >
                              {menu.menu_name}
                            </Typography>
                          )}
                        </MenuItem>
                      </div>
                    );
                  })}
                </MenuList>
                {/* </div> */}
              </div>
            </Sider>
          </div>
        </>
      )}
    </>
  );
};

export default SiderComponent;
